export default __webpack_public_path__ + "static/media/ca.6f7c1f03.svg";